exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#description[data-v-74f6829b]{white-space:pre-line}.rule[data-v-74f6829b]{padding-left:4px;border-left:4px solid #c3e6cb}.ruleDisabled[data-v-74f6829b]{border-left:4px solid #f5c6cb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-74f6829b","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/property-qc/handlers/DescriptionRuleHandler.vue
// module id = 818
// module chunks = 0